import type { IconNode } from '../types';

/**
 * @name nut
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYuODQ3IDUuODQ3IDIwIDlhNy4yMyA3LjIzIDAgMDExLjU1MSA3LjUxNkMyMS4yNDEgMTcuMzUyIDIxIDE3LjkzMiAyMSAxOXYxYTEgMSAwIDAxLTEgMWgtMWMtMS4wNjkgMC0xLjY0OC4yNDItMi40ODUuNTUyQTcuMiA3LjIgMCAwMTkuMDAyIDIwbC0zLjE1NS0zLjE1MyIgLz4KICA8cGF0aCBkPSJNMTguMjEgNS40M2MtMS43MS42OS01LjA3IDEuMDctNi43MSAxLjA3LjQ2IDEuMzguOTEgMi43NC42MSA0Ljg4YS44OC44OCAwIDAxLS43My43NGMtMS43OC4yOC0zLjU0LS4xNy00Ljg4LS42MiAwIDEuNjQtLjM4IDUtMS4wNyA2LjcxLS4yMS41Mi0uODIuNTUtMS4xNy4xMkExMCAxMCAwIDAxMTguMzMgNC4yNmMuNDMuMzUuNC45Ny0uMTIgMS4xNyIgLz4KICA8cGF0aCBkPSJNNC45MyA0LjkzIDMgM2EuNy43IDAgMDEwLTEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/nut
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Nut: IconNode = [
  [
    'path',
    {
      d: 'M16.847 5.847 20 9a7.23 7.23 0 011.551 7.516C21.241 17.352 21 17.932 21 19v1a1 1 0 01-1 1h-1c-1.069 0-1.648.242-2.485.552A7.2 7.2 0 019.002 20l-3.155-3.153',
    },
  ],
  [
    'path',
    {
      d: 'M18.21 5.43c-1.71.69-5.07 1.07-6.71 1.07.46 1.38.91 2.74.61 4.88a.88.88 0 01-.73.74c-1.78.28-3.54-.17-4.88-.62 0 1.64-.38 5-1.07 6.71-.21.52-.82.55-1.17.12A10 10 0 0118.33 4.26c.43.35.4.97-.12 1.17',
    },
  ],
  ['path', { d: 'M4.93 4.93 3 3a.7.7 0 010-1' }],
];

export default Nut;
